import apiClient from './client';

export const ActivityAgeGenderAxiosInstance = apiClient;